import { YYYY_MM_DD } from 'aegion_common_utilities/lib/format/datetime';

import { setFromAndTo, setType, setEnabled, setIsInitialized, clear } from './actions';

import {
	getDateRangeTypeMeta,
	sanitizeDateRangeTypeKey
} from '../util/DateRangeTypes';
import {
	selectDateRangeType,
	selectDateRangeTo,
	selectDateRangeFrom,
	selectThisSlice
} from '../selectors';
import RADR_UTIL from '../util.urlWriter';


const _thunkWriteToUrl = () => (dispatch, getState) => {
  const { type, from, to, enabled } = selectThisSlice(getState());
  RADR_UTIL.setValueInUrl(type, from, to, enabled);
}

const _thunkClearUrl = () => () => {
  RADR_UTIL.setValueInUrl();
}

const thunkClear = () => (dispatch) => {
  dispatch(clear());
  dispatch(_thunkClearUrl());
}

const thunkSetEnabled = (enabled, { preventUrlWrite = false } = {}) => (dispatch) => {
  dispatch(setEnabled(enabled));
  if (!preventUrlWrite) {
    dispatch(_thunkWriteToUrl());
  }
}

const thunkSetFromAndTo = (payload = {}, { preventUrlWrite = false } = {}) => dispatch => {
	const { from: paramFrom, to: paramTo } = payload;
	const from = paramFrom instanceof Date ? YYYY_MM_DD(paramFrom) : paramFrom;
	const to = paramTo instanceof Date ? YYYY_MM_DD(paramTo) : paramTo;
	dispatch(setFromAndTo({ from, to }));
  if (!preventUrlWrite) {
    dispatch(_thunkWriteToUrl());
  }
};

const thunkSetType = (type, { preventUrlWrite = false } = {}) => (dispatch, getState) => {
	const key = sanitizeDateRangeTypeKey(type);
	const meta = getDateRangeTypeMeta(key);

	const root = selectThisSlice(getState());
	const currType = selectDateRangeType(root);
	const currFrom = selectDateRangeFrom(root);
	const currTo = selectDateRangeTo(root);

	if (key !== currType) {
		const from = meta.computeNewFrom(currFrom, currTo);
		const to = meta.computeNewTo(currFrom, currTo);

		dispatch(setType(key));
		dispatch(thunkSetFromAndTo({ from, to }, { preventUrlWrite }));
	}

  if (!preventUrlWrite) {
    dispatch(_thunkWriteToUrl());
  }
};


const thunkLoadStateFromUrl = () => (dispatch) => { 
  if (!RADR_UTIL.CACHE.isLoaded) {
    RADR_UTIL.loadCacheFromUrl();
    const { PROPS: URL_PROPS } = RADR_UTIL.CACHE;
    const { type, from, to, enabled } = URL_PROPS;
    if (enabled) {
      dispatch(thunkSetFromAndTo({ from, to }, { preventUrlWrite: true }));
      dispatch(thunkSetType(type, { preventUrlWrite: true }));
      dispatch(setEnabled(true));
    }
    dispatch(setIsInitialized(true));
  }
}
export { thunkSetFromAndTo, thunkSetType, thunkSetEnabled, thunkClear, thunkLoadStateFromUrl };

export default {
	thunkSetFromAndTo,
  thunkSetType,
  thunkSetEnabled,
  thunkClear,
  thunkLoadStateFromUrl,
};
